import { render } from "./RuleFormReviewView.vue?vue&type=template&id=73f72d29"
import script from "./RuleFormReviewView.vue?vue&type=script&lang=js"
export * from "./RuleFormReviewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleForm/RuleFormReviewView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73f72d29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73f72d29', __exports__)) {
    api.reload('73f72d29', __exports__)
  }
  
  module.hot.accept("./RuleFormReviewView.vue?vue&type=template&id=73f72d29", () => {
    api.rerender('73f72d29', render)
  })

}


export default __exports__